import { render, staticRenderFns } from "./markdown-field-dialog.vue?vue&type=template&id=c2debef6&"
import script from "./markdown-field-dialog.vue?vue&type=script&lang=js&"
export * from "./markdown-field-dialog.vue?vue&type=script&lang=js&"
import style0 from "./markdown-field-dialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2debef6')) {
      api.createRecord('c2debef6', component.options)
    } else {
      api.reload('c2debef6', component.options)
    }
    module.hot.accept("./markdown-field-dialog.vue?vue&type=template&id=c2debef6&", function () {
      api.rerender('c2debef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/markdown-field-dialog/markdown-field-dialog.vue"
export default component.exports